var app = app || {};
( function( $ ) {

   app.core = new function () {
      this.flag = {
         smoothScroll: {scrolling: false, direction: false}
      };

      //get event cursor position
      this.pointerEventToXY = function(e){
         var out = {x:0, y:0};
         if(e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'){
            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            out.x = touch.pageX;
            out.y = touch.pageY;
         } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave') {
            out.x = e.pageX;
            out.y = e.pageY;
         }
         return out;
      };

      //set the title attr
      this.setDataTitle = function($ele, which) {
         if ($ele.attr('data-title-on') && which == 'on') {
            $ele.attr('title', $ele.attr('data-title-on'));
         }
         else if ($ele.attr('data-title-off') && which == 'off') {
            $ele.attr('title', $ele.attr('data-title-off'));
         }

      };

      //calculate the next scene up or down position
      this.calculateNextScenePosition = function (params) {

         //class name of the increasing elem
         var sceneClass = params.sceneClass || 'scene';

         //direction of next scene
         var direction = params.direction || 'down';

         //top offset
         var topOffset = params.topOffset || 0;

         //scrollbar position of the scene
         var position = false;
         var currentScene = 0;

         var numScene = $('.' + sceneClass).length;
         var scrollbar = $(document).scrollTop() + topOffset;
         if (direction === 'up') {
            for (i = numScene - 1; i >= 0; i--) {
               var nextScene = parseInt($('.' + sceneClass + ':eq(' + i + ')').offset().top, 10);
               if (scrollbar > nextScene) {
                  position = nextScene;
                  currentScene = i;
                  break;
               }
            }
         }
         else {
            //smart scroll
            for (i = 0; i < numScene; i++) {
               var nextScene = parseInt($('.' + sceneClass + ':eq(' + i + ')').offset().top, 10);
               if (scrollbar < nextScene) {
                  position = nextScene;
                  currentScene = i;
                  break;
               }
            }
         }
         return {position: position, scene: currentScene};
      };
      this.calculateCurrentScenePosition = function (params) {

         //class name of the increasing elem
         var sceneClass = params.sceneClass || 'scene';
         //scrollbar position of the scene
         var position = false;
         var currentScene = 0;

         var scrollbar = $(document).scrollTop();
         var windowHeight = parseInt($(window).height(), 10);
         var halfWindowHeight = windowHeight / 1.5;

         $('.' + sceneClass).each(function (i) {
            var nextScene = parseInt($(this).offset().top, 10);

            var nextSceneHeight = parseInt($(this).height(), 10);

            if ((scrollbar >= nextScene - halfWindowHeight) && (scrollbar < nextScene + nextSceneHeight - halfWindowHeight) ) {
               position = nextScene;
               currentScene = i + 1;
               return false;
            }
         });


         return {position: position, scene: currentScene};
      };


      //calculate current anchor
      this.calculateCurrentAnchorPosition = function (params) {

         //class name of the increasing elem
         var sceneClass = params.sceneClass || 'anchor';
         var topOffset = parseInt(params.topOffset, 10) || 0;

         //scrollbar position of the scene
         var position = false;
         var currentScene = 0;
         var currentSceneId = '';


         var scrollbar = $(document).scrollTop();
         var totalAnchor = $('.' + sceneClass).length;

         $($('.' + sceneClass).get().reverse()).each(function (i) {
            var nextScene = parseInt($(this).offset().top, 10);
            if (scrollbar >= nextScene - topOffset) {
               position = nextScene;
               currentScene = totalAnchor - i;
               currentSceneId = $(this).attr('id');
               return false;
            }
         });

         return {position: position, scene: currentScene, id: currentSceneId};
      };

      //scroll to position using easing animation
      this.smoothScroll = function (params) {

         //position of the window scrollbar to scroll to
         var position = parseInt(params.position, 10);

         //direction of scrolling
         var direction = params.direction || 'down';

         //animation time in ms
         var time = params.time || 1000;

         //easing effect to use
         var easing = params.ease || 'easeInOutQuad';

         //callback function for when scolling animation is finished
         var onComplete = params.onComplete || false;

         //container
         var container = params.container || 'html,body';

         //dont do anything if we are still in the process of scrolling in the same direction
         if (app.core.flag.smoothScroll.scrolling && direction === app.core.flag.smoothScroll.direction) {
            return;
         }
         app.core.flag.smoothScroll.scrolling = true;
         app.core.flag.smoothScroll.direction = direction;

         $(container).stop().animate({scrollTop: position}, {
            duration: time,
            easing: easing,
            always: function () {
               app.core.flag.smoothScroll.scrolling = false;
               if (onComplete) {
                  onComplete();
               }
            },
         });




      };

      //parse string of format: "myVar:value,myVar2:value2" into array: array.myVar = value
      this.parseDataOptions = function (str) {
         var params = false;
         if (str) {
            params = {};
            var options = str.split(',');
            for (var key in options) {
               var param = options[key].split(':');
               var name = param[0];
               var value = param[1];
               params[name] = value;
            }
         }
         return params;
      };


      //resize element with respect to window
      //collections of classes to resize element dynamically
      this.initDynamicResize = function () {


         //set min height of the element to height of the window
         var minWindowHeight = function () {
            $('.js-min-window-height').each(function () {
               var options = app.core.parseDataOptions($(this).attr('data-min-window-height'));

               //do nothing if window width falls under setting
               if (options.disableUnderWidth && parseInt($(window).width(), 10) < parseInt(options.disableUnderWidth, 10)) {
                  return;
               }
               $(this).css({minHeight: Math.floor($(window).height())});
               if (options.minHeight && parseInt($(window).height(), 10) < parseInt(options.minHeight, 10)) {
                  $(this).css({minHeight: parseInt(options.minHeight, 10)});

               }
            });

         };

         //set height of element to height of window
         var windowHeight = function () {

            $('.js-window-height').each(function () {
               var options = app.core.parseDataOptions($(this).attr('data-window-height'));
               var offset = options.offset || 0;

               //do nothing if window width falls under setting
               if (options.disableUnderWidth && parseInt($(window).width(), 10) < parseInt(options.disableUnderWidth, 10)) {
                  return;
               }
               $(this).css({height: Math.floor($(window).height() - offset)});

               if (options.minHeight && parseInt($(window).height(), 10) < parseInt(options.minHeight, 10)) {
                  $(this).css({height: parseInt(options.minHeight, 10)});
               }


            });

         };

         //set height of element to class
         var parentHeight = function () {

            $('.js-parent-height').each(function () {
               var options = app.core.parseDataOptions($(this).attr('data-parent-height'));
               var $parent = $(this).parents('.' + options.class);
               $(this).css({height: Math.floor($parent.height())});

            });

         };

         $(document).on('app:viewUpdate.initDynamicResize', function (event) {
            minWindowHeight();
            windowHeight();
            parentHeight();
         });

         //call when first initialize
         minWindowHeight();
         windowHeight();
         parentHeight();
         setTimeout(function () {
            parentHeight();
         }, 500);

      };


      //reload if switching device screen size
      this.reloadScreenSize = function () {
         var dontReloadDueToVideoFullScreen = false;
         var dontReloadTimer = false;
         var getDevice = function () {
            if (app.main.isMobile()) {
               return 'mobile';
            }
            else if (app.main.isTablet()) {
               return 'tablet';
            }

            else {
               return 'desktop';
            }
         };
         var currentDevice = getDevice();

         //don't reload when we detect window going into full screen
         $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
            var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
            var event = state ? 'FullscreenOn' : 'FullscreenOff';
            clearTimeout(dontReloadTimer);
            if (event == 'FullscreenOn') {
               dontReloadDueToVideoFullScreen = true;
            }
            else {
               setTimeout(function(){
                  dontReloadDueToVideoFullScreen = false;
               }, 1000);

            }

         });

         $(document).on('app:init.reloadScreenSize app:viewUpdate.reloadScreenSize', function (event, data) {
            if (dontReloadDueToVideoFullScreen) {
               return;
            }
            if (currentDevice !== getDevice()) {
               window.location.reload();
               window.location.href = window.location.href;
               return;
            }
         });

      };

      //move element when in mobile
      this.responsiveMove = function () {
         var mobileMove = function () {
            if (app.main.isMobile()) {
               $('.js-mobile-move').each(function () {
                  var options = app.core.parseDataOptions($(this).attr('data-mobile-move'));
                  $(this).appendTo(options.moveToId);
                  $(this).removeClass('js-mobile-move');
               });
            }
         };
         var tabletMove = function () {
            if (app.main.isTablet() || app.main.isMobile()) {
               $('.js-tablet-move').each(function () {
                  $(this).removeClass('js-tablet-move');
                  var options = app.core.parseDataOptions($(this).attr('data-tablet-move'));
                  $(this).appendTo(options.moveToId);

               });
            }
         };
         var tabletPortraitMove = function () {
            if (app.main.isTabletPortrait() || app.main.isMobile()) {
               $('.js-tabletportrait-move').each(function () {
                  $(this).removeClass('js-tabletportrait-move');
                  var options = app.core.parseDataOptions($(this).attr('data-tabletportrait-move'));
                  $(this).appendTo(options.moveToId);

               });
            }
         };

         $(document).off('app:viewUpdate.responsiveMove').on('app:viewUpdate.responsiveMove', function (event) {
            mobileMove();
            tabletMove();
            tabletPortraitMove();
         });

         mobileMove();
         tabletMove();
         tabletPortraitMove();
      };

      //load different assets for different screen sizes
      this.responsiveLoad = function() {
         var init = function(){
            $('.js-responsive-load').each(function(){
               if (app.main.isMobile() && $(this).attr('data-src-mobile')) {
                  $(this).attr('src', $(this).attr('data-src-mobile'));
               }
               else if (app.main.isTablet() && $(this).attr('data-src-tablet')) {
                  $(this).attr('src', $(this).attr('data-src-tablet'));
               }
               else {
                  $(this).attr('src', $(this).attr('data-src'));
               }
            });
         };
         $(document).on('app:load app:contentLoaded app:viewUpdate', function(){
            init();
         });
      };

      //make horizontal scrollable area for mobile
      this.initMobileHorizontal = function () {

         var createContainer = function () {
            if (app.main.isMobile()) {
               $('.js-mobile-horizontal').each(function () {
                  if (!$(this).hasClass('mobile-horizontal--created')) {
                     $(this).wrap('<div class="mobile-container"><div class="mobile-horizontal"></div></div>');
                     $(this).addClass('mobile-horizontal__width mobile-horizontal--created');
                     $(this).parent().parent().append('<i class="grabicon" aria-hidden="true"></i>');
                  }
                  $(this).on('click.initMobileHorizontal touchstart.initMobileHorizontal', function () {
                     $(this).off('click.initMobileHorizontal touchstart.initMobileHorizontal').parent().parent().find('.grabicon').remove();
                  });
               });
            }
         };

         $(document).off('app:viewUpdate.initMobileHorizontal').on('app:viewUpdate.initMobileHorizontal', function () {
            createContainer();
         });
         createContainer();

      };
      //make horizontal scrollable area for mobile
      this.initTabletHorizontal = function () {

         var createContainer = function() {
            if (app.main.isTablet()) {
               $('.js-tablet-horizontal').each(function () {
                  if (!$(this).hasClass('tablet-horizontal--created')) {
                     $(this).wrap('<div class="tablet-container"><div class="tablet-horizontal"></div></div>');
                     $(this).addClass('tablet-horizontal__width tablet-horizontal--created');
                     $(this).parent().parent().append('<i class="grabicon" aria-hidden="true"></i>');
                  }
                  $(this).on('click.initTabletHorizontal touchstart.initTabletHorizontal', function(){
                     $(this).off('click.initTabletHorizontal touchstart.initTabletHorizontal').parent().parent().find('.grabicon').remove();
                  });
               });
            }
         };

         $(document).off('app:viewUpdate.initTabletHorizontal').on('app:viewUpdate.initTabletHorizontal', function () {
            createContainer();
         });
         createContainer();

      };



      //detect if table requires horizontal scroll bar
      this.responsiveTable = function() {

         $('.wp-block-table, .overflow, .js-responsive-table').each(function(){
            if ($(this).hasClass('is-too-big')) {
               return;
            }
            var maxWidth = parseInt($(this).width());
            if($(this).find('table').width() > maxWidth && $(this).attr('aria-hidden')!='true') {
               $(this).addClass('is-too-big');
            }
         });
      };

      //detect scroll up or down on an element and return direction to the callback
      this.mouseWheelDirection = function (params) {
         var elem = params.elem || 'window';
         var callback = params.callback || false;
         var preventDefault = params.preventDefault || false;
         $(elem).on('mousewheel.mouseWheelDirection DOMMouseScroll.mouseWheelDirection', function (e) {

            var direction = 'down';
            if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
               direction = 'up';
            }
            callback.call(this, direction);

            if (preventDefault) {
               return false;
            }


         });
      };


      //update the hashbang url
      this.updateHashBang = function (hashbang) {
         window.location.hash = hashbang;

      };

      //create an event when hashbang changes and return the parsed hashbang as an array
      this.registerHashBangEvent = function (triggerOnLoad) {

         //should the event trigger on page load if there is hashbang
         var triggerOnLoad = triggerOnLoad || false;

         //open page, scroll to section based on the hashbang value
         var executeHashBang = function () {
            var hashbang = window.location.hash;

            //check if #! is in the url, do nothing and return if there is no #!
            var pos = hashbang.indexOf('#!');
            if (pos < 0) {
               return false;
            }

            //there is #! value, parse it
            var params = app.core.parseHashOptions(hashbang.slice(pos + 2));
            return params;
         };

         var triggerEvent = function () {
            //get the params in the hashbang
            var params = executeHashBang();
            if (params) {
               $(document).trigger('app:hashbang', params);
            }
            oldHash = window.location.hash;
         };

         //parse the hashbang when hash changes and trigger urlChange event
         $(window).on('hashchange.initHashBangEvent', function () {
            triggerEvent();
         });

         //trigger hashchange event when click, regardless if hash change or not since clicking a link with the same hash as the current hash wont trigger event
         $('.js-trigger-hashchange').on('click.initHashBangEvent', function () {
            var newHash = $(this).attr('href').split('#');
            if (newHash[1]) {
               newHash = '#'+newHash[1];
            }
            if (newHash == window.location.hash) {
               triggerEvent();
            }
         });

         //trigger the event on page load as well
         if (triggerOnLoad) {
            triggerEvent();
         }
      };


      //parse hashbang url string into array of params
      this.parseHashOptions = function (str) {
         var params = false;
         if (str) {
            params = {};
            var options = str.split('&');
            for (var key in options) {
               var param = options[key].split('=');
               var name = param[0];
               var value = param[1];
               params[name] = value;
            }
         }
         return params;
      };


      this.createCookie = function (name, value, days) {
         if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
         }
         else
         var expires = "";
         document.cookie = name + "=" + value + expires + "; path=/; SameSite=Lax;";
      };

      this.readCookie = function (name) {
         var nameEQ = name + "=";
         var ca = document.cookie.split(';');
         for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
         }
         return null;
      };

      this.eraseCookie = function (name) {
         app.core.createCookie(name, "", -1);
      };

      this.initGaClickTrack = function () {

         $(document).on('click.initGaClickTrack', '.js-ga-track', function () {
            app.core.gaEvent({
               category: $(this).attr('data-ga-category'),
               action: $(this).attr('data-ga-action'),
               label: $(this).attr('data-ga-label'),
            });
         });

         $(document).on('click.initGaClickTrackExternal', '.js-ga-external-link', function () {
            app.core.gaEvent({
               category: 'external link',
               action: 'click',
               label: $(this).attr('href').replace(/\/$/, ''),
            });
         });
      };
      this.gaEvent = function (params) {
         var label = params.label;
         var category = params.category || 'user-action';
         var action = params.action || 'click';
         if (typeof gtag != "undefined") {
            gtag('event', action, {
               'event_category': category,
               'event_label': label,
            });
         }
         else if (typeof ga != "undefined") {
            ga('send', 'event', category, action, label, {hitCallback:
               function () {

               }
            });
         }

      };
      this.gaPageview = function (path) {
         var path = path || window.location.pathname + window.location.search + window.location.hash;
         if (typeof gtag != "undefined" && WORKS_GLOBAL_GTAG_UA_IDS) {
            for(i in WORKS_GLOBAL_GTAG_UA_IDS) {
               gtag('config', WORKS_GLOBAL_GTAG_UA_IDS[i], {'page_path': path});
            }
         }
         else if (typeof ga != "undefined") {
            ga('send', 'pageview', path);
         }
      };

      //turn the value of sParam in the url
      this.GetURLParameter = function (sParam) {
         var sPageURL = window.location.search.substring(1);
         var sURLVariables = sPageURL.split('&');
         for (var i = 0; i < sURLVariables.length; i++)
         {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam)
            {
               return sParameterName[1];
            }
         }
         return false;
      };




      //detect mobile or tablet browser
      this.isMobileDevice = function () {
         if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(navigator.userAgent)) {
            return true;
         }
         else {
            return false;
         }
      };

      this.parseHTML = function(htmlstr) {
         //var dom = new DOMParser().parseFromString(htmlstr, "text/html");
         var tmp = false;
         var html = {fullContent: htmlstr, ajaxContent:"", title:""};
         html.fullContent = htmlstr;

         //get the ajax content without header and footer
         tmp = htmlstr.match(/<!--CONTENT START-->([\s\S]+)<!--CONTENT END-->/);
         if (tmp && tmp[1]) {
            html.ajaxContent = tmp[1];
         }
         //get the meta title
         tmp = htmlstr.match(/<title>([\s\S]+)<\/title>/);
         if (tmp[1]) {
            html.title = tmp[1];
         }
         return html;
      };
      //update location bar url
      this.replaceUrl = function (url) {
         if (window.history && history.replaceState) {
            history.replaceState({}, '', url);
         }
      };
      //update location bar url
      this.pushUrl = function (url, state, callback) {
         //remember the previous url for going back/closing current url
         if (window.history && history.pushState) {
            history.pushState({}, '', url);
         }

      };
   };


})(jQuery);
